let config;

switch (location.hostname) {
	case 'media.oneflowcloud.com':
	case 'media-ui-s3cf.oneflowcloud.com':
	case 'pdf-viewer.oneflowcloud.com':
	case 'pdf-viewer-s3cf.oneflowcloud.com':
		config = {
			rasterApi: 'https://media-api.oneflowcloud.com'
		};
		break;
	case 'media-ui.stage-a.hpgsb.net':
		config = {
			rasterApi: 'https://media-api.media.stage-a.hpgsb.net'
		};
		break;
	case 'media-ui.dev-a.hpgsb.net':
	case 'localhost':
		config = {
			rasterApi: 'https://media-api.media.dev-a.hpgsb.net'
		};
		break;
}

export default config;



// WEBPACK FOOTER //
// ./src/config.js